import { UserProfile } from './profile/UserProfile';
import { PageNotFound } from '@/app/core/components/PageNotFound';
import {
  buildDefaultHomeNavItem,
  useMainNav,
} from '@/app/core/components/main-nav';
import { useDefaultLayoutState, useSetPageTitle } from '@/app/store';
import { usePathContext } from '@ssar-app/okta-authn-react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useEffect, useMemo } from 'react';

export const UserProfilePage = () => {
  useSetPageTitle('User Account');
  const { buildPath } = usePathContext();

  const { setNavItems } = useMainNav();
  const { isSiderCollapsed } = useDefaultLayoutState();

  const navItems = useMemo(() => {
    const navItem = buildDefaultHomeNavItem(
      isSiderCollapsed,
      buildPath('/profile'),
      'Profile',
    );
    return [navItem];
  }, [buildPath, isSiderCollapsed]);

  useEffect(() => {
    setNavItems(navItems);
    return () => {
      setNavItems([]);
    };
  }, [buildPath, isSiderCollapsed, navItems, setNavItems]);
  return (
    <Switch>
      <Route path={buildPath(`/profile`)}>
        <UserProfile />
      </Route>
      <Route exact path={buildPath('/')}>
        <Redirect to={buildPath(`/profile`)} />
      </Route>
      <Route path='*'>
        <PageNotFound />
      </Route>
    </Switch>
  );
};
UserProfilePage.whyDidYouRender = true;
